import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { AssignorLead, GestorCadastro } from 'src/app/models/gestor-cadastro';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';
import { GestorService } from 'src/app/services/gestor.service';
import { NgBrazilValidators } from 'ng-brazil';

import { RegisterService } from 'src/app/services/register.service';
import { CedenteGestorCadastro } from 'src/app/models/cedentegestor-cadastro';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { GestorRegistro } from 'src/app/models/gestor-registro';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { NgxMatPopoverComponent } from '@exalif/ngx-mat-popover';
import { CedenteService } from 'src/app/services/cedente.service';

@Component({
  selector: 'app-register-gestor-account',
  templateUrl: './register-gestor-account.component.html',
  styleUrls: ['./register-gestor-account.component.css']
})
export class RegisterGestorAccountComponent implements OnInit {

  private gestorCadastro: GestorCadastro;
  public gestorCadastroFormGroup: FormGroup;
  private cedenteGestorCadastro: CedenteGestorCadastro;

  public get form() { return this.gestorCadastroFormGroup.controls; }

  @ViewChild('popover') popover: NgxMatPopoverComponent;

  constructor(
    private formBuilder: FormBuilder,
    private gestorService: GestorService,
    private assignorService: CedenteService,
    private alertService: NewAlertService,
    private registerService: RegisterService,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.registerService.currentCadastro.subscribe(
      response => {
        this.cedenteGestorCadastro = response;
      }
    );
    if (this.cedenteGestorCadastro === null) {
      this.router.navigate(['']);
    }
    this.gestorCadastro = this.cedenteGestorCadastro.gestorCadastro;
    this.createForm(this.gestorCadastro);
  }

  ngAfterViewInit() {
    this.assignorService.registerAssignorLead(
      new AssignorLead(
        this.gestorCadastro.companyName,
        this.gestorCadastro.numberOfEmployees,
        this.gestorCadastro.nome,
        this.gestorCadastro.cpf,
        parseInt(this.gestorCadastro.telefoneNumero),
        this.gestorCadastro.dataNascimento,
        this.gestorCadastro.email,
        this.gestorCadastro.emailConfirmacao
      )
    ).subscribe();
  }

  createForm(gestorCadastro: GestorCadastro) {
    this.gestorCadastroFormGroup = this.formBuilder.group({
      nome: new FormControl(gestorCadastro.nome, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100)
      ]),
      cpf: new FormControl(gestorCadastro.cpf, [
        Validators.required,
        NgBrazilValidators.cpf
      ]),
      telefoneNumero: new FormControl(gestorCadastro.telefoneNumero, [
        Validators.required,
        NgBrazilValidators.telefone
      ]),
      dataNascimento: new FormControl(gestorCadastro.dataNascimento, [
        Validators.required,
        GenericValidator.isAdult
      ]),
      email: new FormControl(gestorCadastro.email, [
        Validators.required,
        Validators.email
      ]),
      emailConfirmacao: new FormControl(gestorCadastro.emailConfirmacao, [
        Validators.required,
        Validators.email,
        GenericValidator.mustMatch('email')
      ]),
      senha: new FormControl(gestorCadastro.senha, [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(10)
      ]),
      senhaConfirmacao: new FormControl(gestorCadastro.senhaConfirmacao, [
        Validators.required,
        GenericValidator.mustMatch('senha')
      ])
    });
  }

  onSubmit(gestorCadastro: GestorCadastro) {
    if (this.gestorCadastroFormGroup.valid) {
      gestorCadastro.cpf = gestorCadastro.cpf.replace(/\D+/g, '').replace(' ', '');
      gestorCadastro.telefoneNumero = gestorCadastro.telefoneNumero.replace(/\D+/g, '').replace(' ', '');

      // validar e-mail
      this.gestorService.validarRegistro(new GestorRegistro(gestorCadastro.email, gestorCadastro.senha, gestorCadastro.cpf, gestorCadastro.dataNascimento, gestorCadastro.telefoneNumero)).subscribe(
        response => {
          if (response.status === ApiError.Sucesso) {
            if (response.result) {
              this.alertService.success(response.message);
              this.cedenteGestorCadastro.gestorCadastro = gestorCadastro;
              this.registerService.changeCedenteGestorCadastro(this.cedenteGestorCadastro);
              this.router.navigate(['cedente'], { relativeTo: this.route.parent });
            } else {
              this.alertService.error(response.message);
            }
          } else {
            this.alertService.error(response.message);
          }
        }
      );
    }
  }
}
